import { Component, Inject, Input, OnInit } from '@angular/core';
import { ObjetivosAreaJardinModel, SubdimensionModel } from 'src/app/model/FaseEstrategica.model';
import { FaseEstrategicaComponent } from '../fase-estrategica.component';

@Component({
  selector: 'app-subdimension-fe',
  templateUrl: './subdimension-fe.component.html',
  styleUrls: ['./subdimension-fe.component.css']
})
export class SubdimensionFEComponent implements OnInit {

  @Input() indice : number;
  @Input() estadoData : number;
  @Input() areaNumber : number;
  @Input() subdimensionData : SubdimensionModel;
  @Input() simulacion: boolean;
  
  objetivosAreaJardin = new ObjetivosAreaJardinModel();


  constructor(
    @Inject(FaseEstrategicaComponent) private parentFE: FaseEstrategicaComponent,
  ) { }

  ngOnInit(): void {  

  }
  

  change(){
    this.parentFE.cambios = true;
  }
}
